import tw, { styled } from 'twin.macro';

export const StyledInformationStripe = styled.aside`
  ${tw`w-full`}
  ${tw`bg-secondary-s1`}
  ${tw`z-40`}
  ${tw`relative`}
`;

export const Wrapper = styled.div`
  ${tw`container`}
  ${tw`flex items-center justify-center gap-1 lg:gap-3 flex-col lg:flex-row`}
  ${tw`w-full`}
  ${tw`px-[40px] py-2 lg:py-[10px]`}
  ${tw`text-center md:text-left`}
`;

export const StyledTitle = styled.span`
  ${tw`font-inter font-medium`}
  ${tw`text-body-s text-neutrals-n1`}
`;

export const StyledLink = styled.a`
  ${tw`font-inter font-medium`}
  ${tw`text-body-s text-neutrals-n1`}
  ${tw`underline`}
`;

export const CloseButtonWrapper = styled.div`
  ${tw`flex justify-end items-end`}
  ${tw`w-auto`}
  ${tw`absolute top-[4px] right-[4px]`}
  ${tw`cursor-pointer`}
`;
